module.exports = __webpack_public_path__ + "img/selected3-min.d4c03475.png";